import { Translator } from 'Translator';
import CityCarousel from 'components/CityCarousel';
import useCitiesByCountry from 'components/CitySliderByCountry/useCitiesByCountry';
import PageContentBlock from 'components/PageContentBlock';
import SectionTitle from 'components/SectionTitle';
import React from 'react';
import { translateCountry } from 'utils/TranslationHelper';

const CSS = require('./CitySliderByCountry.less');

type CitySliderByCountryProps = {
  country: string;
  minimumCities?: number;
  show?: boolean;
  ignoreFilters?: boolean;
};

const CitySliderByCountry = ({
  country,
  minimumCities = 2,
  show = true,
  ignoreFilters = false,
}: CitySliderByCountryProps) => {
  const cities = useCitiesByCountry(country);

  if (cities.length < minimumCities || !show) {
    return null;
  }

  return (
    <PageContentBlock topSpacing>
      <SectionTitle>
        {Translator.translate(
          'Common.Labels.citiesInCountry',
          {
            country: translateCountry(country),
            withlocals: <span className={CSS.WithlocalsTitle}>Withlocals</span>,
          },
          false,
          '{withlocals} cities in {country}',
        )}
      </SectionTitle>
      <CityCarousel destinations={cities} ignoreFilters={ignoreFilters} />
    </PageContentBlock>
  );
};

export default CitySliderByCountry;
